import { BoxProps, FormControl } from "@chakra-ui/react";
import { ComboBox, ComboBoxItem } from "src/components/base/combo-box";
import { IUserReaction } from "src/components/user-reactions/types";

interface IDropDownSelector extends Omit<BoxProps, "onChange"> {
    reactions: Pick<IUserReaction, "underlyingIsin" | "underlyingName">[];
    selectedUnderlyingIsin: string;
    onChange: (underlyingIsin: string) => void;
}

export const DropDownSelector = ({ reactions, selectedUnderlyingIsin, onChange, ...props }: IDropDownSelector) => {
    return (
        <FormControl w={["100%", "300px"]} {...props}>
            <ComboBox
                value={selectedUnderlyingIsin}
                isDisabled={reactions.length === 1}
                onChange={onChange}
                inputBoxProps={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                    overflow: "hidden",
                    textAlign: "left",
                    pr: 3,
                }}
                menuListProps={{
                    maxH: 256,
                    width: ["327px", "300px"],
                }}
            >
                {reactions.map(({ underlyingIsin, underlyingName }) => (
                    <ComboBoxItem
                        key={underlyingIsin}
                        value={underlyingIsin!}
                        sx={{ textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inherit", overflow: "hidden", fontSize: "md" }}
                        h={5}
                    >
                        {underlyingName}
                    </ComboBoxItem>
                ))}
            </ComboBox>
        </FormControl>
    );
};
